import { render, staticRenderFns } from "./supplierPrivacyPolicyModal.vue?vue&type=template&id=67846bc0&scoped=true"
import script from "./supplierPrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./supplierPrivacyPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./supplierPrivacyPolicyModal.vue?vue&type=style&index=0&id=67846bc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67846bc0",
  null
  
)

export default component.exports